import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import axios from "axios";
import VueAxios from "vue-axios";
axios.defaults.withCredentials = true;
Vue.use(VueAxios, axios);

//jQuery
import jQuery from "jquery";
global.jQuery = jQuery;
global.$ = jQuery;
window.$ = window.jQuery = require("jquery");

Vue.config.productionTip = false;

// FontAwesome
import { library } from "@fortawesome/fontawesome-svg-core";
import { fas } from "@fortawesome/free-solid-svg-icons";
library.add(fas);
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";
Vue.component("fa-icon", FontAwesomeIcon);

import moment from "moment";
moment.locale("ja");

import LoadScript from "vue-plugin-load-script";
Vue.use(LoadScript);

new Vue({
  router,
  store,
  render: (h) => h(App),
}).$mount("#app");
